<script lang="ts">
	import Breadcrumbs from '$lib/components/Breadcrumbs.svelte';
	import type { PageData, Snapshot } from './$types';
	import FilterPage from '$lib/components/Page/FilterPage.svelte';
	import { T, getTranslate } from '@tolgee/svelte';

	export let data: PageData;

	const { t } = getTranslate();

	let scrollY = 0;
	export const snapshot: Snapshot<number> = {
		capture: () => scrollY,
		restore: (value) => (scrollY = value)
	};

	let metaDefaultTitle: string = data?.collectionData?.collection
		? $t('meta.default.title', { title: data.collectionData.collection?.title })
		: '';
	let metaDefaultDescription: string = data?.collectionData?.collection
		? $t('meta.default.description.collections', {
				title: data.collectionData.collection?.title
			})
		: '';
</script>

<svelte:window bind:scrollY />

<svelte:head>
	{#if data?.collectionData?.collection}
		{@const metaTitle = data?.collectionData?.collection.metaTitle?.value}
		{@const metaDescription = data?.collectionData?.collection.metaDescription?.value}
		<title>{metaTitle || metaDefaultTitle}</title>
		<meta name="description" content={metaDescription || metaDefaultDescription} />
	{/if}
</svelte:head>

<main class="box-x-wrapper">
	<Breadcrumbs collectionPath={JSON.parse(data.collectionData?.collection?.path?.value || '[]')} />
	<FilterPage
		collectionData={data.collectionData}
		collectionInfo={data.collectionInfo?.story?.content}
		facetResponse={data.facetResponse}
		searchResponse={data.searchResponse}
		typeInformation={data.typeInformation}
		filterData={data.filterData}
	/>
</main>
